import { HTMLAttributes, PropsWithChildren } from 'react'

export interface AccordionProps extends HTMLAttributes<HTMLDetailsElement> {
  summary: string
  'data-testid': string
}

export default function Accordion({
  summary,
  className,
  children,
  'data-testid': dataTestId,
  ...props
}: PropsWithChildren<AccordionProps>) {
  const classNames = ['cmp-accordion', className].join(' ').trim()

  return (
    <details className={classNames} data-emphasis="high" {...props}>
      <summary className="my-4 sm:my-1" data-testid={`${dataTestId}-summary`}>
        {summary}
      </summary>
      <div className="pb-1" data-testid={`${dataTestId}-div`}>
        {children}
      </div>
    </details>
  )
}
